module.exports = __webpack_public_path__ + "media/images/nav/icon_7-f243ca38083919d16c59c109c89949c8.svg";